// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.background-white[data-v-27a989ad] {\r\n  background: #fff;\n}\n.allig-gate-passage-edit\r\n  .theme--light.v-data-table\r\n  > .v-data-table__wrapper\r\n  > table\r\n  > tbody\r\n  > tr[data-v-27a989ad]:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {\r\n  background: #fff;\n}\n.allig-select[data-v-27a989ad] {\r\n  width: 80px;\n}\r\n", ""]);
// Exports
module.exports = exports;
